import React from "react";

export function TechStackCard({title, path}) {
    return(
        <>
            <div className={'md:text-[20px] text-[12px] hover:shadow-xl transition-shadow ease-in-out flex flex-col md:px-4 md:py-2 py-1 mx-1 my-1 bg-white rounded-lg shadow-sm items-center'}>
                <img src={require(`${path}`)} alt={title} className={'md:w-[50px] md:h-[50px] w-[25px] h-[25px]'} />
                <div className={'  md:font-[500] font-[400]'}>
                    <span>{title}</span>
                </div>
            </div>
        </>
    )
}
export function LinkCard({title, path, link}) {
    return(
        <>
            <a href={link} target="_blank">
                <div className={'hover:shadow-xl transition-shadow ease-in-out flex flex-col md:px-4 md:py-2 py-1 mx-1 my-1 px-1 bg-white rounded-lg shadow-sm items-center'}>
                    <img src={require(`${path}`)} alt={title} className={'md:w-[50px] md:h-[50px] w-[25px] h-[25px]'} />
                    <div className={'md:text-[24px] text-[12px] md:font-[600] font-[400]'}>
                        <span>{title}</span>
                    </div>
                </div>
            </a>
        </>
    )
}


export function ProjectCard({title, description, path, live, link, codeAvailable, codeLink}){
    return(
        <>
            <div className={'md:w-[800px] md:h-[400px] w-[300px] h-[200px] flex flex-col px-4 py-2 md:mx-3 sm:mx-1 my-2 bg-white shadow-sm items-center'}>
                <div className={'md:text-[36px] text-[24px] font-[600] pt-2'}>
                    <span>{title}</span>
                </div>
                <div className={'flex'}>
                    <div className={'md:pt-10'}>
                        <div className={'italic md:text-[18px] text-[12px] font-[400] text-[#6e6e73]'}>
                            <span>{description}</span>
                        </div>
                        {live==="true" && codeAvailable==="true" && <div className={'flex'}>
                            <div className={'md:text-[18px] text-[12px] font-[500] pt-5 mr-3'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={link} target="_blank">Live</a></button>
                            </div>
                            <div className={'md:text-[18px] text-[12px] font-[500] pt-5'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={codeLink} target="_blank">Code</a></button>
                            </div>
                        </div>}
                        {live==="false" && codeAvailable==="true" && <div className={'flex'}>
                            <div className={'md:text-[18px] text-[12px] font-[500] pt-5'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={codeLink} target="_blank">Code</a></button>
                            </div>
                        </div>}
                        {live==="true" && codeAvailable==="false" && <div className={'flex'}>
                            <div className={'md:text-[18px] text-[12px] font-[500] pt-5'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={link} target="_blank">Live</a></button>
                            </div>
                        </div>}
                    </div>
                    <img src={require(`${path}`)} alt={title} className={'object-fill md:w-[500px] md:h-[300px] w-[200px] h-[80px]'} />
                </div>
            </div>
        </>
    )
}

export function ProjectCardTiny({title, description, live, link, codeAvailable, codeLink}){
    return(
        <>
            <div className={'hover:shadow-xl hover:scale-105 transition ease-in-out overflow-y-auto md:w-[250px] md:h-[100px] sm:w-[200px] h-[80px] w-[150px] flex flex-col px-4 py-2 mx-1 my-1 bg-white shadow-sm '}>
                <div className={'md:text-[18px] text-[12px] font-[500]'}>
                    <span>{title}</span>
                </div>
                <div className={'flex'}>
                    <div className={''}>
                        <div className={'italic sm:text-[12px] text-[10px] font-[400] text-[#6e6e73]'}>
                            <span>{description}</span>
                        </div>
                        {live==="true" && codeAvailable==="true" && <div className={'flex'}>
                            <div className={'text-[12px] font-[500] pt-1'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={link} target="_blank">Live</a></button>
                            </div>
                            <div className={'text-[12px] font-[500] pt-1 px-2 '}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={codeLink} target="_blank">Code</a></button>
                            </div>
                        </div>}
                        {live==="false" && codeAvailable==="true" && <div className={'flex'}>
                            <div className={'text-[12px] font-[500] pt-1'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={codeLink} target="_blank">Code</a></button>
                            </div>
                        </div>}
                        {live==="true" && codeAvailable==="false" && <div className={'flex'}>
                            <div className={'text-[12px] font-[500] pt-1'}>
                                <button className={'text-[#6e6e73] hover:text-[#000000]'}><a href={link} target="_blank">Live</a></button>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export function ExperienceCard({title, start, end, organization, description, }) {
    return(
        <>
            <div className={'overflow-y-auto md:h-[200px] h-[150px] flex flex-col px-4 py-2 mx-3 my-2 bg-white shadow-sm'}>
                <div className={'md:text-[24px] text-[18px] font-[500] pt-2'}>
                    <span>{title}</span>
                </div>
                <div className={'flex'}>
                    <div className={''}>
                        <div className={'italic md:text-[18px] text-[12px] font-[400] text-[#6e6e73]'}>
                            <span>{organization}</span>
                        </div>
                        <div className={'md:text-[18px] text-[12px] font-[300]'}>
                            <span>{start} - {end}</span>
                        </div>
                        <div className={'md:pt-5 md:text-[18px] text-[12px] font-[300] text-[#6e6e73]'}>
                            <span>{description}</span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export function OtherWorkCard({title, organization, description, link}) {
    return(
        <>
            <div className={' overflow-y-auto md:h-[120px] h-[70px] flex flex-col px-4 py-2 mx-3 my-1 bg-white shadow-sm'}>
                <div className={' md:pt-2 flex items-center'}>
                    <span className={'md:font-[500] font-[400] md:text-[24px] text-[14px]'}>{title}</span>
                    <div className={'md:font-[400] font-[300] md:text-[20px] text-[12px] italic font-[400] text-[#6e6e73] px-2'}>
                        <span>{organization}</span>
                    </div>
                </div>
                <div className={''}>
                    <div className={'flex justify-between'}>
                        <div className={'md:pt-2 md:text-[18px] text-[12px] font-[300] text-[#6e6e73]'}>
                            <span>{description}</span>
                        </div>
                        {link!=="" &&<div className={'md:pt-2 md:text-[18px] text-[12px] font-[500] text-[#6e6e73] px-3'}>
                            <button className={'text-black'}><a href={link} target="_blank">Link</a></button>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}